import type { Dayjs } from 'dayjs'

import Skeleton from '@mui/material/Skeleton'
import { getRelativeFuture } from 'shared/time'

import css from './UpcomingEvents.module.css'

function SkeletonList() {
	return (
		<ol className={css.list}>
			{[1, 2].map(i => (
				<li className={css.item} key={i}>
					<Skeleton
						className={css.skeletonCircle}
						height='1rem'
						variant='circular'
						width='1rem'
					/>

					<Skeleton variant='text' width={'20ch'} />
				</li>
			))}
		</ol>
	)
}

const TimeSpan = ({ date }: { date: Dayjs }) => (
	<time
		className={css.timer}
		dateTime={date.toISOString()}
		title={date.format('DD MMM YYYY HH:mm')}
	>
		{getRelativeFuture(date)}
	</time>
)

const TimeSpanFull = ({ date }: { date: Dayjs }) => (
	<time className={css.timer} dateTime={date.toISOString()}>
		{date.format('DD MMM YYYY HH:mm')}
	</time>
)

export { SkeletonList, TimeSpan, TimeSpanFull }
